import React from 'react'
// import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import Icon from '../../assets/icons/Icon'

// import Icon from 'assets/icons/Icon'

const Room = ({ data, isClickable, activeSoundsLoaded, chapterName, setImageClicked, screenFromQuery, t, i }) => {
  // const { t } = useTranslation('common')
  let history = useHistory()

  // const [blurFocus, setBlurFocus] = useState(6)

  const enterFullScreen = () => {
    if (!document.fullscreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement) {
      const doc = document.documentElement
      if (doc.requestFullscreen) {
        doc.requestFullscreen()
      } else if (doc.webkitRequestFullscreen) {
        /* Safari */
        doc.webkitRequestFullscreen()
      } else if (doc.msRequestFullscreen) {
        /* IE11 */
        doc.msRequestFullscreen()
      }
    }
  }

  const onImageClick = () => {
    setImageClicked(true)
    enterFullScreen()
    let url = `/${chapterName}`
    if (process.env.NODE_ENV !== 'production') {
      url = `/${chapterName}`
    }
    history.push(url)
    // } else {
    //   setBlurFocus((prev) => prev - 2)
    // }
  }

  // const onImageScroll = useCallback(() => {
  //   setBlurFocus((prev) => prev - 0.1)
  // }, [setBlurFocus])

  return (
    data.roomContent && (
      <div className="wallImgWrapper">
        <img
          src={data.wallImg}
          data-depth="0.6"
          alt="pic"
          // style={{
          //   filter: `blur(${blurFocus}px)`,
          // }}
          className={`imageWithFocus slide__content ${chapterName} ${
            i === screenFromQuery || i === screenFromQuery + 1 || i === screenFromQuery + 2 || i === screenFromQuery - 1
              ? 'display'
              : ''
          }`}
          onClick={onImageClick}
          // onWheel={onImageScroll}
        />
        <div className="clickPhoto">
          <Icon name="arrowRight" width={16} height={22} stroke="white" />
          {t('clickPhoto')}
        </div>
      </div>
    )
  )
}

export default Room
